import { render, staticRenderFns } from "./LkLinks.vue?vue&type=template&id=6c790b68&scoped=true"
import script from "./LkLinks.vue?vue&type=script&lang=js"
export * from "./LkLinks.vue?vue&type=script&lang=js"
import style0 from "./LkLinks.vue?vue&type=style&index=0&id=6c790b68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c790b68",
  null
  
)

export default component.exports